module.exports = __webpack_public_path__ + "img/sv19.5cec5701.svg";